import _ from "lodash";

require('../../bootstrap');

import Vue from 'vue';
import ComponentSet from "../../ComponentSet";
import utils from "../../Utils";
import Constants from "../../Constants";

import * as rules from 'vee-validate/dist/rules';
import en from 'vee-validate/dist/locale/en.json';
import {extend, localize, setInteractionMode, ValidationObserver, ValidationProvider} from 'vee-validate';

// -------------------------------------------------------
//                  VeeValidate 設定
// -------------------------------------------------------
localize('en', en);
setInteractionMode('eager');

Object.keys(rules).forEach(rule => {
    extend(rule, rules[rule]);
});

const components = _.assign(ComponentSet, { ValidationProvider, ValidationObserver,} );

// --------------------------------------------------------------
//                          主程式
// --------------------------------------------------------------
const app = new Vue({
    components: components,
    mixins: [utils],
    data: { 
        token  : "",        
        email  : "",
    },
    created() {
        // 使用 Utils 的 method 設定
        //defaultOnCreated(this);
    },
    beforeDestroy() {

    },
    mounted() {
        let self = this;
        self.loadToken(self, 'forgot_password');
    },
    methods: {
        submitData(){
            
            let url  = Constants.serverRoot+`/frontend/verify-token2`;
            let self = this;

            this.showLoading = true;

            _.set(this, 'contentData.form.email' , this.email);
            _.set(this, 'contentData.form.token' , this.token);
            _.set(this, 'contentData.form.currentUrl' , Constants.serverRoot+`/api/forgot-password`);

            this.$http.post(url, _.get(self, 'contentData.form', null))
                .then(function (response){
                    let data = response.data.Value;
                    if (data.success) {
                        self.$refs.observer.reset();
                    }
                    self.showMessage({ config: {
                        msg: data.message
                    }});
                    self.showLoading = false;
                    self.loadToken(self, 'forgot_password');
                })
                .catch(function (error) {
                    self.showMessage({ config: {
                        msg: '請稍後再試。'
                    }});
                    self.showLoading = false;
                    self.loadToken(self, 'forgot_password');
                })
        }
    }, // end of methods
    computed: {
        serverRoot() {
            return Constants.serverRoot
        }
    }, // end of computed
}).$mount('#app');